import { push } from '@talend/router-bridge';

import { CadReduxAction, CustomAttributeDefinition, CustomAttributeForm } from '../../CAD.types';
import {
	SET_CAD_FORM_DATA,
	SET_CAD_FORM_BEGIN_LOADING,
	SET_CAD_FORM_STOP_LOADING,
	GET_CUSTOM_ATTRIBUTE_DEFINITION_FORM_DATA,
	UPDATE_CUSTOM_ATTRIBUTES_DEFINITION,
	CREATE_CUSTOM_ATTRIBUTES_DEFINITION,
} from './CADForm.constants';

export const setCADFormBeginLoadingAction = { type: SET_CAD_FORM_BEGIN_LOADING };
export const setCADFormStopLoadingAction = {
	type: SET_CAD_FORM_STOP_LOADING,
};
export const setCADFormDataAction = (data: CustomAttributeForm): CadReduxAction => ({
	type: SET_CAD_FORM_DATA,
	payload: data,
});

export const getCustomAttributeFormDataAction = (id: string): CadReduxAction => ({
	type: GET_CUSTOM_ATTRIBUTE_DEFINITION_FORM_DATA,
	payload: {
		id,
	},
});

export const sendCustomAttributeDefinitionUpdate = (
	id: string,
	value: CustomAttributeDefinition,
): CadReduxAction => ({
	type: UPDATE_CUSTOM_ATTRIBUTES_DEFINITION,
	payload: {
		id,
		value,
	},
});

export const sendCADDefinitionCreation = (value: CustomAttributeDefinition): CadReduxAction => ({
	type: CREATE_CUSTOM_ATTRIBUTES_DEFINITION,
	payload: {
		value,
	},
});

export const goToCADListAction = push('/custom-attributes/', null, { type: 'GO_TO_CAD_LIST' });
